import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.10537 4.71471C2.28632 4.27813 2.67109 4 3.09387 4H14.9077C15.3316 4 15.7144 4.27813 15.8949 4.71471C16.0781 5.15128 16.0207 5.66786 15.7308 6.04162L10.751 13.0284V17.0004C10.751 17.3785 10.565 17.7254 10.2669 17.8942C9.9716 18.0629 9.61609 18.0286 9.35082 17.8004L7.60063 16.3004C7.37912 16.1129 7.25059 15.816 7.25059 15.5003V13.0284L2.24727 6.04162C1.97963 5.66786 1.92439 5.15128 2.10539 4.71471H2.10537Z",
		fill: "#0D2976"
	})
});
export default SvgFilter;
